/**
 * Shared trigger/menu styling for the app's custom form controls
 * (Select, DatePicker, …). Single source so every control renders at the
 * same height with the same 3px-radius elevated look.
 */

export const CONTROL_SIZE = {
  md: {
    trigger: 'py-2.5 pr-9 text-[13px]',
    padLeft: 'pl-3.5',
    padLeftIcon: 'pl-9',
    item: 'px-3 py-2 text-[13px]',
    icon: 'right-3 h-4 w-4',
    check: 'h-3.5 w-3.5',
    popoverText: 'text-[13px]',
    dayCell: 'h-8 w-8 text-[12px]',
  },
  sm: {
    trigger: 'py-1.5 pr-8 text-xs',
    padLeft: 'pl-2.5',
    padLeftIcon: 'pl-8',
    item: 'px-2.5 py-1.5 text-xs',
    icon: 'right-2.5 h-3.5 w-3.5',
    check: 'h-3 w-3',
    popoverText: 'text-xs',
    dayCell: 'h-7 w-7 text-[11px]',
  },
} as const

export type ControlSize = keyof typeof CONTROL_SIZE

export const TRIGGER_CLASSES = [
  'w-full appearance-none rounded-[3px] bg-white text-left',
  'font-medium text-slate-700',
  // Soft ring + shadow — matches the dashboard cards' elevation.
  'ring-1 ring-slate-900/[0.08] shadow-[0_1px_2px_rgba(15,23,42,0.05)]',
  'cursor-pointer transition-all duration-150',
  'hover:ring-slate-900/[0.16] hover:shadow-[0_2px_8px_-2px_rgba(15,23,42,0.12)]',
  'focus:outline-none focus:ring-2 focus:ring-indigo-500/50',
  'disabled:cursor-not-allowed disabled:bg-slate-50 disabled:text-slate-400 disabled:ring-slate-900/[0.04]',
].join(' ')

export const POPOVER_CLASSES =
  'absolute top-full z-50 mt-1.5 rounded-[3px] bg-white ring-1 ring-slate-900/10 shadow-[0_8px_24px_-6px_rgba(15,23,42,0.18),0_2px_6px_rgba(15,23,42,0.08)]'

/** Anchors a popover to the trigger's right edge when it would overflow the viewport. */
export const popoverSide = (alignRight: boolean): string => (alignRight ? 'right-0' : 'left-0')
